import { TicketStatus } from "@/common/types/support/ticket.type";

export const supportTicketsTotalizerClassName: Partial<Record<TicketStatus, string>> = {
  not_responded: 'text-red-400', 
  in_progress: 'text-red-400',
  pending: 'text-red-400', 
  awaiting_customer_response: 'text-red-400',
  awaiting_tcard_response: 'text-red-400',
  closed: 'text-valid',
};